import { Modal } from '@/components/dialog/modal';
import Message from '@/components/message/message';
import { userInfoStore } from '@/models';
import { uploadFile } from '@/services/api/file';
import { updateOrganizationLogoUrlApi } from '@/services/api/notice';
import { LoadingButton } from '@mui/lab';
import { Box, Button, DialogContent, Stack, Typography } from '@mui/material';
import React, { forwardRef, ForwardRefRenderFunction, useImperativeHandle, useState } from 'react';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';

export interface IChangeLogoModalRef {
  open: () => void
}

export interface IChangeLogoModalProps {
  onOK: (value: string) => void
}

const uploadBox: React.CSSProperties = {
  height: 100,
  width: '100%',
  paddingTop: 8,
  border: '1px solid #ccc',
  textAlign: 'center',
  cursor: 'pointer',
  borderRadius: 8,
};
const ChangeLogoModalFun: ForwardRefRenderFunction<IChangeLogoModalRef, IChangeLogoModalProps> = (props, ref) => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [files, setFiles] = useState<FileList|null>(null);
  const handleClose = () => {
    setOpen(false);
  };
  const handleReset = () => {
    handleSubmitUrl('');
  };
  const handleSubmitUrl = async (url: string) => {
    try {
      await updateOrganizationLogoUrlApi({
        organizationId: userInfoStore.organizationId,
        logoUrl: url,
      });
      Message.open('success', { variant: 'success' });
      setFiles(null);
      props.onOK(url);
      handleClose();
    } catch (error) {
      Message.error(error as Error);
    }
  };
  const handleSelectFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    const allowedTypes = ['image/jpeg', 'image/png'];
    if (!files || files.length <= 0) {
      return;
    }
    if (!allowedTypes.includes(files[0].type)) {
      Message.open('請上傳jpg或png格式的圖片', { variant: 'warning' });
      return;
    }
    setFiles(files);
  };
  // 選擇文件回調
  const handleUpload = async () => {
    if (!files || files.length <= 0) {
      return;
    }
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('Buffer', files[0]);
      const res = await uploadFile(formData);
      if (res.Data && res.Data.Url) {
        await handleSubmitUrl(res.Data.Url);
      }
      setLoading(false);
    } catch (error) {
      Message.error(error as Error);
      setLoading(false);
    }
  };
  useImperativeHandle(ref, () => ({
    open: () => {
      setOpen(true);
      setFiles(null);
      setLoading(false);
    },
  }));
  return (
    <Modal open={open} modalTitle="上傳公司logo" onCloseBtnClick={handleClose} fullWidth>
      <DialogContent dividers>
        <Box>
          <label htmlFor="select-img" style={{ display: 'block' }}>
            <input id='select-img' type="file" accept="image/*" onChange={handleSelectFile} style={{ display: 'none' }}/>
            <div style={uploadBox}>
              <AddPhotoAlternateIcon sx={{ fontSize: 50 }}/>
              {files && files.length > 0 && (<Typography>{files[0].name}</Typography>)}
            </div>
          </label>
        <Typography>建議圖片大小220x50px</Typography>
        </Box>
        <Stack direction={'row'} justifyContent={'center'} spacing={1}>
          <Button size='small' variant='contained' color='warning' onClick={handleReset}>重置</Button>
          <LoadingButton size='small' variant='contained' disabled={!files || files.length < 1} loading={loading} onClick={handleUpload}>提交</LoadingButton>
        </Stack>
      </DialogContent>
    </Modal>
  );
};

export const ChangeLogoModal = forwardRef(ChangeLogoModalFun);
